
class ProductForm extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector("form");
        this.isInfluencerProduct = this.getAttribute('data-influencer-product')
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
            this.submitButton.setAttribute("aria-haspopup", "dialog");
    }

    onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner")?.classList.remove("hidden");
        this.querySelector(".loading-overlay__pdp")?.classList.remove("hidden");
        this.querySelector(".loading-overlay__pdp .loading-overlay__dots")?.classList.remove("hidden");
        this.querySelector('.product-btn_text')?.classList.add('hidden');

        // Klaviyo Added to Cart Event
        const variantId = this.form.querySelector("[name=id]").value;

        // const itemData = this.submitButton.dataset.productData.replace(/'/g,"\""); 

        const itemData = this.submitButton.dataset.productData;
        let sellingPlanData = this.dataset.sellingPlanId
        console.log('sellingPlanData',sellingPlanData)

        if (itemData){
            const itemDataParsed = JSON.parse(itemData);
            var item = {
                "productId": variantId,
                "productTitle": itemDataParsed.title,
                "productPrice": itemDataParsed.price,
                "productImage": itemDataParsed.featured_image,
                "productURL": 'https://revisionskincare.com/products/' + itemDataParsed.handle
            }
        }


        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
            formData.append(
                "sections",
                this.cart.getSectionsToRender().map((section) => section.section)
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
        }
        if(sellingPlanData){
           
            formData.append("selling_plan", sellingPlanData);
            
        }
        config.body = formData;

        let influencer = document.querySelector('body').getAttribute('data-influencer-in-cart')
        // CLEAR CART IF INFLUENCER PRODUCT IS ADDED
        if ( this.isInfluencerProduct == 'true' ){
            $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                success: function(){
                    console.log('cart cleared')

                    fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                            this.handleErrorMessage(response.description);
        
                            const soldOutMessage =
                                this.submitButton.querySelector(".sold-out-message");
                            if (!soldOutMessage) return;
                            this.submitButton.setAttribute("aria-disabled", true);
                            this.submitButton.querySelector("span").classList.add("hidden");
                            soldOutMessage.classList.remove("hidden");
                            this.error = true;
                            return;
                        } else if (!this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                        }
        
                        this.error = false;
                        const quickAddModal = this.closest(".modal");
                        if (quickAddModal) {
                            document.body.addEventListener(
                                "modalClosed",
                                () => {
                                    setTimeout(() => {
                                        this.cart.renderContents(response);
                                    });
                                },
                                { once: true }
                            );
                            quickAddModal.hide(true);
                        } else {
                            this.cart.renderContents(response);
                        }
                        initSampleSlider();
                        if(document.querySelector("body[data-template='cart']")){
                            sampleModalFunction();
                        }

                        
                        if(document.querySelector("body[data-template='cart']")){
                            renderCartUpsell();
                        }    
                        updateGwpPrice();
                        checkInfluencerQuantity();
                        if (item) {
                            addedToCart(item);
                        }

                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.submitButton.classList.remove("loading");
                        if (this.cart && this.cart.classList.contains("is-empty"))
                            this.cart.classList.remove("is-empty");
                        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                        this.querySelector(".loading-overlay__spinner").classList.add("hidden");

                        // if (window.matchMedia('(max-width: 1010px)').matches) {
                            
                        // }

                      
                        document.querySelector('cart-drawer').open()

                        setTimeout(update_shopify_ju_cart,1000);
                        console.log('justuno!')

                    });
                },
                dataType: 'json'
              });
        }
        else{
            if (influencer != 'true' ) {

                fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        this.handleErrorMessage(response.description);
    
                        const soldOutMessage =
                            this.submitButton.querySelector(".sold-out-message");
                        if (!soldOutMessage) return;
                        this.submitButton.setAttribute("aria-disabled", true);
                        this.submitButton.querySelector("span").classList.add("hidden");
                        soldOutMessage.classList.remove("hidden");
                        this.error = true;
                        return;
                    } else if (!this.cart) {
                        window.location = window.routes.cart_url;
                        return;
                    }
    
                    this.error = false;
                    const quickAddModal = this.closest(".modal");
                    if (quickAddModal) {
                        document.body.addEventListener(
                            "modalClosed",
                            () => {
                                setTimeout(() => {
                                    this.cart.renderContents(response);
                                });
                            },
                            { once: true }
                        );
                        quickAddModal.hide(true);
                    } else {
                        this.cart.renderContents(response);
                    }
                    initSampleSlider();
                    if(document.querySelector("body[data-template='cart']")){
                        sampleModalFunction();
                    }
                    if(document.querySelector("body[data-template='cart']")){
                        renderCartUpsell();
                    }    
                  
                    updateGwpPrice();
                    checkInfluencerQuantity()
                    if(item) {
                        addedToCart(item);
                    }



                    this.querySelector(".loading-overlay__pdp .loading-overlay__dots")?.classList.add("hidden");
                    this.querySelector(".loading-overlay__pdp .loading-overlay__success")?.classList.remove("hidden");
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.submitButton.classList.remove("loading");
                    if (this.cart && this.cart.classList.contains("is-empty"))
                        this.cart.classList.remove("is-empty");
                    if (!this.error) this.submitButton.removeAttribute("aria-disabled");
                    

                    setTimeout(() => {
                        this.querySelector(".loading-overlay__pdp")?.classList.add("hidden");
                        this.querySelector(".loading-overlay__pdp .loading-overlay__dots")?.classList.add("hidden");
                        this.querySelector(".loading-overlay__pdp .loading-overlay__success")?.classList.add("hidden");
                        this.querySelector('.product-btn_text')?.classList.remove('hidden')
                    }   , 5000);

                    // if (window.matchMedia('(max-width: 1010px)').matches) {
            
                    // }
                    document.querySelector('cart-drawer').open()
                    setTimeout(update_shopify_ju_cart,1000);
                    console.log('justuno!')


                });
            } else{
                console.log('influencer product')
                this.querySelector('.atc-error-message').textContent = 'Other products cannot be added to cart with influencer product';
                this.querySelector('.atc-error-message').classList.remove('visually-hidden');
                this.submitButton.classList.add('width--full')

                setTimeout(() => {
                    this.querySelector('.atc-error-message').classList.add('visually-hidden');
                    this.submitButton.classList.remove('width--full')
                }   , 7000);
            }
        }



  
           
    }

    handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector(".product-form-error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
            this.errorMessage ||
            this.errorMessageWrapper.querySelector(".product-form-error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
        }
    }
}
customElements.define("product-form", ProductForm);
class QuickAddModal extends ModalDialog {
    constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
        const cartNotification =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
    }

    show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");

        fetch(opener.getAttribute("data-product-url"))
            .then((response) => response.text())
            .then((responseText) => {
                const responseHTML = new DOMParser().parseFromString(
                    responseText,
                    "text/html"
                );
                this.productElement = responseHTML.querySelector(
                    'section[id^="MainProduct-"]'
                );
                this.preventDuplicatedIDs();
                this.removeDOMElements();
                this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

                if (window.Shopify && Shopify.PaymentButton) {
                    Shopify.PaymentButton.init();
                }

                if (window.ProductModel) window.ProductModel.loadShopifyXR();

                this.removeGalleryListSemantic();
                this.updateImageSizes();
                this.preventVariantURLSwitching();
                super.show(opener);
            })
            .finally(() => {
                opener.removeAttribute("aria-disabled");
                opener.classList.remove("loading");
                opener
                    .querySelector(".loading-overlay__spinner")
                    .classList.add("hidden");
            });
    }

    setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll("script").forEach((oldScriptTag) => {
            const newScriptTag = document.createElement("script");
            Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
            });
            newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
    }

    preventVariantURLSwitching() {
        this.modalContent
            .querySelector("variant-radios,variant-selects")
            .setAttribute("data-update-url", "false");
    }

    removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector(
            "pickup-availability"
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector("product-modal");
        if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
        );
        this.productElement
            .querySelectorAll("variant-selects, variant-radios")
            .forEach((variantSelect) => {
                variantSelect.dataset.originalSection = sectionId;
            });
    }

    removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
            '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
            .querySelectorAll('[id^="Slide-"]')
            .forEach((li) => li.setAttribute("role", "presentation"));
    }

    updateImageSizes() {
        const product = this.modalContent.querySelector(".product");
        const desktopColumns = product.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
            "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
            mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
            mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) => img.setAttribute("sizes", mediaImageSizes));
    }
}
customElements.define("quick-add-modal", QuickAddModal);
class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener(
            "keyup",
            (event) => event.code === "Escape" && this.close()
        );
        this.querySelector("#CartDrawer-Overlay").addEventListener(
            "click",
            this.close.bind(this)
        );

        this.querySelector("#CartDrawer-close").addEventListener(
            "click",
            this.close.bind(this)
        );

        this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector("#cart-bubble");
        const cartOverly = document.querySelector('.cart-drawer-overlay')
        
        if (!cartLink) {
            console.error('Cart bubble element not found');
            return;
        }
        
        // Since it's already a button element, we don't need to set role="button"
        cartLink.setAttribute("aria-haspopup", "dialog");
        cartLink.setAttribute("tabindex", "0"); // Ensure it's focusable
        
        if (window.matchMedia('(min-width: 1011px)').matches) {
            cartLink.addEventListener("mouseover", (event) => {
                event.preventDefault();
                this.open(cartLink);
            });
        }
        if (window.matchMedia('(max-width: 1010px)').matches) {
            cartLink.addEventListener("click", (event) => {
                event.preventDefault();
                this.open(cartLink);
            });
        }

    
        // Use click event for both mouse and keyboard activation (more reliable for screen readers)
        cartLink.addEventListener("click", (event) => {
            event.preventDefault();
            this.open(cartLink);
        });
        
        // Keep keydown as backup for explicit keyboard handling
        cartLink.addEventListener("keydown", (event) => {
            if (event.code === "Enter" || event.code === "Space") {
                event.preventDefault();
                event.stopPropagation();
                this.open(cartLink);
            }
        });
    }

    open(opener) {
        if(document.querySelector('body[data-template="cart"]')){
            return
        }
        if (opener) this.setActiveElement(opener);
        this.openBy = opener;
        this.setAttribute("open", "");
        this.querySelector(".cart-drawer-content").classList.add("active");

        trapFocus(this, this.querySelector('[role="dialog"]'));

        document.body.classList.add("cart-drawer-opening", "overflow-hidden");
    }

    close() {
        this.querySelector(".cart-drawer-content").addEventListener(
            "transitionend",
            () => {
                removeTrapFocus(this.openBy);
                this.removeAttribute("open");
                document.body.classList.remove(
                    "cart-drawer-opening",
                    "overflow-hidden"
                );
            },
            { once: true }
        );

        this.querySelector(".cart-drawer-content").classList.remove("active");
    }

    renderContents(parsedState) {

        this.querySelector(".cart-drawer-content").classList.contains("is-empty") &&
            this.querySelector(".cart-drawer-content").classList.remove("is-empty");

        this.getSectionsToRender().forEach((section => {
            const elementToReplace =
                document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
            if (elementToReplace)
                elementToReplace.innerHTML =
                    this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));



        // if( !document.querySelector("body[data-template='cart']")){
        //     this.open();
        // }
        initSampleSlider();
        if(document.querySelector("body[data-template='cart']")){
            sampleModalFunction();
        }
        if(document.querySelector("body[data-template='cart']")){
            renderCartUpsell();
        }    
      

        updateGwpPrice();
        checkInfluencerQuantity()

    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector)?.innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: "CartDrawer",
                section: "cart-drawer",
                selector: ".cart-drawer-inner",
            },
            {
                id: "cart-bubble",
                section: "header",
                selector: ".minicart-icon",
            },
            {
                id: "main-cart-items",
                section: document.getElementById("main-cart-items")?.dataset.id,
                selector: ".js-contents",
            }
        ];
    }

    getSectionDOM(html, selector = ".shopify-section") {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}
customElements.define("cart-drawer", CartDrawer);
class CartItems extends HTMLElement {
    constructor() {
        super();

        this.lineItemStatusElement =
            document.getElementById("shopping-cart-line-item-status") ||
            document.getElementById("CartDrawer-LineItemStatus");

        this.currentItemCount = Array.from(
            this.querySelectorAll('[name="updates[]"]')
        ).reduce(
            (total, quantityInput) => total + parseInt(quantityInput.value),
            0
        );

        this.debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, 300);

        this.addEventListener("change", this.debouncedOnChange.bind(this));

        // Not needed anymore?
        // setTimeout(()=> {
        //     document.querySelectorAll('cart-items .cart-main-item').forEach((item, index) => {

        //         let rcParent = `form[action="/cart"] #CartDrawer-Item-${index + 1} .cart-recharge-wrapper`;
        //         if(document.querySelector(rcParent)){
        //             var rcParentId = document.querySelector(rcParent)?.getAttribute('data-id')
    
        //             var injectParent = `form[action="/cart"] #CartDrawer-Item-${index + 1} .cart-recharge-wrapper[data-id='${rcParentId}']`
        //             var config = {
        //                 productId: parseInt(item.getAttribute('data-upsell-pd-id')), // Required
        //                 injectionParent: injectParent, // The node that will have the widget injected in
        //                 injectionMethod: 'append', // How will the widget be injected
        //                 injectFn: (node, target) => {}, // Runs a custom injection function
        //                 selectors: {
        //                     price: ['.cart-item-prices'], // the selectors that will be updated based on subscription
        //                     variant: ['.cart-item-option'] // The variants to watch for to update the subscription prices
        //                 }
        //             }
        //         }
        //         if(window.ReChargeWidget && document.querySelector(rcParent) != null){
        //             window.ReChargeWidget.createWidget(config);
        //             setTimeout(function() {
        //                 let rcRadio = document.querySelector(`#CartDrawer-Item-${index + 1} .rc_widget__option__input--subsave`);
    
        //                 if(document.querySelector(rcParent)?.getAttribute('data-is-plan') == 'SellingPlanAllocationDrop'){
        //                     rcRadio?.click();
        //                 }
        //                 var rcDropdown = document.querySelector(`#CartDrawer-Item-${index + 1} .rc-selling-plans select`);
        //                 console.log(rcParent);
        //                 setTimeout(function() {
        //                     document.querySelector(rcParent)?.setAttribute('data-ready', "true");
        //                 }, 500);
        //                 setTimeout(function() {
        //                     if (rcDropdown) {
        //                         for (var i = 0; i < rcDropdown.options.length; i++) {
        //                             if (rcDropdown.options[i].value === document.querySelector(rcParent)?.getAttribute('data-plan-id')) {
        //                                 rcDropdown.selectedIndex = i;
        //                                 break;
        //                             }
        //                         }
        //                     }
        //                 }, 300)
    
        //             }, 100)
        //         }          
        //     })
        // } , 500)


}

    onChange(event) {
        console.log(event)
        if(event.target.closest(".cart-subscription-container")){
            console.log('subscription change', event.target.value)
            
                let lineIndex = parseInt(event.target.closest('.cart-main-item').getAttribute('data-line-index'));
                let quantityItem = parseInt(event.target.closest('.cart-main-item').getAttribute('data-quantity'));

                if (event.target.value == 'onetime'){
                    this.updateSubscription(quantityItem, lineIndex, null,  document.activeElement.getAttribute("name") )
                }else if(event.target.value == 'subsave'){
                    var firstOption = event.target.closest(".cart-subscription-subsave-container").querySelector(".subsave-select option[selected]").value;
                this.updateSubscription(quantityItem, lineIndex, firstOption,  document.activeElement.getAttribute("name"));
                }else{
                    this.updateSubscription(quantityItem, lineIndex, event.target.value,  document.activeElement.getAttribute("name"));
                }
            
        }else if(event.target.closest('.cart-drawer-selling-plan-select')){
            console.log('subscription change', event.target.value)
            let lineIndex = parseInt(event.target.closest('.cart-drawer-item').getAttribute('data-line-index'));
            let quantityItem = parseInt(event.target.closest('.cart-drawer-item').getAttribute('data-quantity'));
            if (event.target.value == 'onetime'){
                this.updateSubscription(quantityItem, lineIndex, null,  document.activeElement.getAttribute("name") )
            }else{
                this.updateSubscription(quantityItem, lineIndex, event.target.value,  document.activeElement.getAttribute("name"));
            }
        }
        else{
            console.log('normal change')
            this.updateQuantity(
                event.target.dataset.index,
                event.target.value,
                event.target.dataset.id,
                document.activeElement.getAttribute("name"),

            );

        }       
    }


    getSectionsToRender() {
        return [
            {
                id: "CartDrawer",
                section: "cart-drawer",
                selector: ".cart-drawer-inner",
            },
            {
                id: "cart-bubble",
                section: "header",
                selector: ".minicart-icon",
            },
            {
                id: "main-cart-items",
                section: document.getElementById("main-cart-items")?.dataset.id,
                selector: ".js-contents",
            }
        ];
    }

    updateSubscription(quantity, line, selling_plan, name, id ) {

        this.enableLoading(line);
        this.querySelectorAll('.quantity__button').forEach((button) => {
            button.classList.add('disable-click')
        })

        const body = JSON.stringify({
            line,
            quantity,
            selling_plan,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
        });
        console.log('body', body)


        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.classList.toggle("is-empty", parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector("cart-drawer");
                const cartFooter = document.getElementById("main-cart-footer");

                if (cartFooter)
                    cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
                if (cartDrawerWrapper)
                    cartDrawerWrapper.classList.toggle(
                        "is-empty",
                        parsedState.item_count === 0
                    );

                this.getSectionsToRender().forEach((section => {
                    const elementToReplace =
                        document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
                    if (elementToReplace)
                        elementToReplace.innerHTML =
                            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }));

                this.updateLiveRegions(line, parsedState.item_count);
                const lineItem =
                    document.getElementById(`CartItem-${line}`) ||
                    document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                    cartDrawerWrapper
                        ? trapFocus(
                            cartDrawerWrapper,
                            lineItem.querySelector(`[name="${name}"]`)
                        )
                        : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                    trapFocus(
                        cartDrawerWrapper.querySelector(".drawer__inner-empty"),
                        cartDrawerWrapper.querySelector("a")
                    );
                } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
                    trapFocus(
                        cartDrawerWrapper,
                        document.querySelector(".cart-item__name")
                    );
                }
                this.disableLoading();
                this.querySelectorAll('.quantity__button').forEach((button) => {
                    button.classList.remove('disable-click')
                })
                initSampleSlider();
                if(document.querySelector("body[data-template='cart']")){
                    sampleModalFunction();
                }
                if(document.querySelector("body[data-template='cart']")){
                    renderCartUpsell();
                }    
              
                updateGwpPrice();
                checkInfluencerQuantity()
            }).finally(() =>{
                initSampleSlider();
                if(document.querySelector("body[data-template='cart']")){
                    sampleModalFunction();
                }
            })
            .catch(() => {
                this.querySelectorAll(".loading-overlay").forEach((overlay) =>
                    overlay.classList.add("hidden")
                );
                const errors =
                    document.getElementById("cart-errors") ||
                    document.getElementById("CartDrawer-CartErrors");
                errors.textContent = window.cartStrings.error;
                this.disableLoading();
                this.querySelectorAll('.quantity__button').forEach((button) => {
                    button.classList.remove('disable-click')
                })
            });

    }

    updateQuantity(line, quantity, id, name) {
        this.enableLoading(line);
        this.querySelectorAll('.quantity__button').forEach((button) => {
            button.classList.add('disable-click')
        })

        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
        });
        // console.log('body', body)


        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.classList.toggle("is-empty", parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector("cart-drawer");
                const cartFooter = document.getElementById("main-cart-footer");

                if (cartFooter)
                    cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
                if (cartDrawerWrapper)
                    cartDrawerWrapper.classList.toggle(
                        "is-empty",
                        parsedState.item_count === 0
                    );

                removeIfOnlyGWP();

                this.getSectionsToRender().forEach((section => {
                    const elementToReplace =
                        document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
                    if (elementToReplace)
                        elementToReplace.innerHTML =
                            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }));

                this.updateLiveRegions(line, parsedState.item_count);
                const lineItem =
                    document.getElementById(`CartItem-${line}`) ||
                    document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                    cartDrawerWrapper
                        ? trapFocus(
                            cartDrawerWrapper,
                            lineItem.querySelector(`[name="${name}"]`)
                        )
                        : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                    trapFocus(
                        cartDrawerWrapper.querySelector(".drawer__inner-empty"),
                        cartDrawerWrapper.querySelector("a")
                    );
                } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
                    trapFocus(
                        cartDrawerWrapper,
                        document.querySelector(".cart-item__name")
                    );
                }
                this.disableLoading();
                this.querySelectorAll('.quantity__button').forEach((button) => {
                    button.classList.remove('disable-click')
                })
                initSampleSlider();
                if(document.querySelector("body[data-template='cart']")){
                    sampleModalFunction();
                }

                if(document.querySelector("body[data-template='cart']")){
                    renderCartUpsell();
                }    
              
                updateGwpPrice();
                checkInfluencerQuantity()
            }).finally(() =>{
                initSampleSlider();
                if(document.querySelector("body[data-template='cart']")){
                    sampleModalFunction();
                }
            })
            .catch(() => {
                this.querySelectorAll(".loading-overlay").forEach((overlay) =>
                    overlay.classList.add("hidden")
                );
                const errors =
                    document.getElementById("cart-errors") ||
                    document.getElementById("CartDrawer-CartErrors");
                errors.textContent = window.cartStrings.error;
                this.disableLoading();
                this.querySelectorAll('.quantity__button').forEach((button) => {
                    button.classList.remove('disable-click')
                })
            });
    }

    updateLiveRegions(line, itemCount) {
        if (this.currentItemCount === itemCount) {
            const lineItemError =
                document.getElementById(`Line-item-error-${line}`) ||
                document.getElementById(`CartDrawer-LineItemError-${line}`);
            const quantityElement =
                document.getElementById(`Quantity-${line}`) ||
                document.getElementById(`Drawer-quantity-${line}`);
            lineItemError.querySelector(".cart-item__error-text").innerHTML =
                window.cartStrings.quantityError.replace(
                    "[quantity]",
                    quantityElement.value
                );
        }

        this.currentItemCount = itemCount;
        this.lineItemStatusElement.setAttribute("aria-hidden", true);

        const cartStatus =
            document.getElementById("cart-live-region-text") ||
            document.getElementById("CartDrawer-LiveRegionText");
        cartStatus.setAttribute("aria-hidden", false);

        setTimeout(() => {
            cartStatus.setAttribute("aria-hidden", true);
        }, 1000);
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        const mainCartItems =
            document.getElementById("main-cart-items") ||
            document.getElementById("CartDrawer-CartItems");
        mainCartItems.classList.add("cart__items--disabled");

        const cartItemElements = this.querySelectorAll(
            `#CartItem-${line} .loading-overlay`
        );
        const cartDrawerItemElements = this.querySelectorAll(
            `#CartDrawer-Item-${line} .loading-overlay`
        );

        [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
            overlay.classList.remove("hidden")
        );

        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute("aria-hidden", false);
    }

    disableLoading() {
        const mainCartItems =
            document.getElementById("main-cart-items") ||
            document.getElementById("CartDrawer-CartItems");
        mainCartItems.classList.remove("cart__items--disabled");
    }
}
customElements.define("cart-items", CartItems);
class CartDrawerItems extends CartItems {
    constructor() {
        super();
    }
}
customElements.define("cart-drawer-items", CartDrawerItems);
class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("click", (event) => {
            event.preventDefault();
            const cartItems =
                this.closest("cart-items") || this.closest("cart-drawer-items");
            cartItems.updateQuantity(this.dataset.index, 0, this.dataset.id );
        });
    }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartNote extends HTMLElement {
    constructor() {
        super();

        this.addEventListener(
            "change",
            debounce((event) => {
                const body = JSON.stringify({ note: event.target.value });
                fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
            }, 300)
        );
    }
}
customElements.define("cart-note", CartNote);



function initSampleSlider() {
    const cartSamplesSlider = new Swiper(".cart-main-samples-product-container", {
        slidesPerView: 1.2,
        spaceBetween: 5,
        watchSlidesProgress: true,
        mousewheel: {
            forceToAxis: true
        },
        navigation: {
            nextEl: '.ss-next-btn-mob',
            prevEl: '.ss-prev-btn-mob'
        },
        breakpoints: {
            1011: {
                freeMode: true,
                slidesPerView: 3.8,
                spaceBetween: 10,
                centeredSlides: false,
                scrollbar: false,
                navigation: {
                    nextEl: '.ss-next-btn',
                    prevEl: '.ss-prev-btn'
                }
            }
        },
    }
);
}

function updateGwpPrice() {
    if (document.querySelector("[data-gwp-original-price]")){
        let total = document.querySelector(".cart-subtotal").getAttribute('data-total').replace(/,/g , "");
        let gwpPrice = document.querySelector("[data-gwp-original-price]").getAttribute('data-gwp-original-price').replace(/,/g , "");
        console.log('gwpPrice', gwpPrice)
    
        let newTotal = total - gwpPrice;
        console.log(newTotal)
        document.querySelector(".cart-subtotal").innerHTML = `$${newTotal}`
    };

    if (document.querySelector("[data-discount-value]")){
        let total = document.querySelector(".cart-subtotal").getAttribute('data-total').replace(/,/g , "");
        let gwpPrice = document.querySelector("[data-discount-value]").getAttribute('data-discount-value').replace(/,/g , "");
        let newTotal = total - gwpPrice;
        console.log(newTotal)
        document.querySelector(".cart-subtotal").innerHTML = `$${newTotal}`
    }

}
updateGwpPrice();

function checkInfluencerQuantity(){
    let influencerQuantity = document.querySelectorAll("[data-influencer-quantity]");
    influencerQuantity?.forEach((item) => {
        let influencerQuantity = item.getAttribute('data-influencer-quantity');

        if (influencerQuantity >= 4){
            document.querySelectorAll("product-form[data-influencer-product='true']").forEach((item) => {
                item.querySelector('button').disabled = true
            })
        }else{
            document.querySelectorAll("product-form[data-influencer-product='true']").forEach((item) => {
                item.querySelector('button').disabled = false
            })
        }
    })
}

checkInfluencerQuantity()

function removeIfOnlyGWP() {

        fetch('/cart.js').then((res) => {
            return res.json();
          }).then((data) => {
            items = data.items;

            const nonGwpItem = items.find((item) => item.product_type !== "R-FREE-GWP");
            const gwpInCart = items.find((item) => item.product_type === "R-FREE-GWP");
            const cartItems =
                        document.querySelector("cart-items") || document.querySelector("cart-drawer-items");
            if (!nonGwpItem && gwpInCart) {
                for (let i = 1; i <= items.length; i++) {
                    cartItems.updateQuantity(i, 0, gwpInCart.id.toString());
                }
            }
        });
}

removeIfOnlyGWP();

function addedToCart(item) {
    fetch(`${window.location.origin}/cart.js`)
    .then(res => res.clone().json().then(data => {
        var cart = {
        total_price: data.total_price/100,
        $value: data.total_price/100,
        total_discount: data.total_discount,
        original_total_price: data.original_total_price/100,
        items: data.items
        }
        if (item !== 'undefined') {
        cart = Object.assign(cart, item)
        }
        _learnq.push(['track', 'Added to Cart', cart]);
    }))
} 


function renderCartUpsell() {
    const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
    
        observer.unobserve(productRecommendationsSection);
    
        const url = productRecommendationsSection.dataset.url;
    
        fetch(url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');
    
            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsSection.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      };
    
      const productRecommendationsSection = document.querySelector('.product-recommendations');
      const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    
      if(productRecommendationsSection){
        observer.observe(productRecommendationsSection);
      }
}

renderCartUpsell();

document.addEventListener('rebuy.add', async function() {
    console.log("Product added via Rebuy widget");

    // Fetch the updated cart data from Shopify
    try {
        const response = await fetch('/cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error('Failed to fetch cart data');
        }

        const cartData = await response.json();

        // Get the cart drawer element
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) {
            console.error('Cart drawer element not found');
            return;
        }

        // Fetch the cart drawer section HTML
        const sectionResponse = await fetch('/?sections=cart-drawer,header,main-cart-items');
        if (!sectionResponse.ok) {
            throw new Error('Failed to fetch section data');
        }

        const sectionsData = await sectionResponse.json();

        // Update the cart drawer contents
        cartDrawer.renderContents({
            sections: sectionsData
        });

        // Open the cart drawer
        cartDrawer.open();
    } catch (error) {
        console.error('Error updating cart drawer:', error);
    }
});
